import { FC } from 'react';
import { ToastContainer } from 'react-toastify';

// breaking out the configuration into a separate provider, plus this
// gives us the ability to use multiple containers if needed.

const ToastProvider: FC = () => (
  <ToastContainer
    position="top-right"
    autoClose={3500}
    hideProgressBar
    newestOnTop
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />
);

export default ToastProvider;
